import { BubbleMenu } from '@tiptap/react';
import { Button, Dropdown, Menu, Tooltip } from 'antd';
import { BgColorsOutlined, TableOutlined } from '@ant-design/icons';
import { ColorTableMenu } from './menu';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var items = function items(editor, labels) {
  return [{
    label: /*#__PURE__*/_jsx(Button, {
      onClick: function onClick() {
        return editor.chain().focus().addColumnBefore().run();
      },
      disabled: !editor.can().addColumnBefore(),
      type: "text",
      children: labels.addColumnBefore
    }),
    key: '0'
  }, {
    label: /*#__PURE__*/_jsx(Button, {
      onClick: function onClick() {
        return editor.chain().focus().addColumnAfter().run();
      },
      disabled: !editor.can().addColumnAfter(),
      type: "text",
      children: labels.addColumnAfter
    }),
    key: '1'
  }, {
    label: /*#__PURE__*/_jsx(Button, {
      onClick: function onClick() {
        return editor.chain().focus().deleteColumn().run();
      },
      disabled: !editor.can().deleteColumn(),
      type: "text",
      children: labels.deleteColumn
    }),
    key: '2'
  }];
};

var itemsRow = function itemsRow(editor, labels) {
  return [{
    label: /*#__PURE__*/_jsx(Button, {
      onClick: function onClick() {
        return editor.chain().focus().addRowBefore().run();
      },
      disabled: !editor.can().addRowBefore(),
      type: "text",
      children: labels.addRowBefore
    }),
    key: '0'
  }, {
    label: /*#__PURE__*/_jsx(Button, {
      onClick: function onClick() {
        return editor.chain().focus().addRowAfter().run();
      },
      disabled: !editor.can().addRowAfter(),
      type: "text",
      children: labels.addRowAfter
    }),
    key: '1'
  }, {
    label: /*#__PURE__*/_jsx(Button, {
      onClick: function onClick() {
        return editor.chain().focus().deleteRow().run();
      },
      disabled: !editor.can().deleteRow(),
      type: "text",
      children: labels.deleteRow
    }),
    key: '2'
  }];
};

var itemsTable = function itemsTable(editor, labels) {
  return [{
    label: /*#__PURE__*/_jsx(Button, {
      onClick: function onClick() {
        return editor.chain().focus().deleteTable().run();
      },
      disabled: !editor.can().deleteTable(),
      type: "text",
      children: labels.deleteTable
    }),
    key: '0'
  }, {
    label: /*#__PURE__*/_jsx(Button, {
      onClick: function onClick() {
        return editor.chain().focus().mergeCells().run();
      },
      disabled: !editor.can().mergeCells(),
      type: "text",
      children: labels.mergeCells
    }),
    key: '1'
  }, {
    label: /*#__PURE__*/_jsx(Button, {
      onClick: function onClick() {
        return editor.chain().focus().splitCell().run();
      },
      disabled: !editor.can().splitCell(),
      type: "text",
      children: labels.splitCell
    }),
    key: '2'
  }];
};

var TableBubbleMenu = function TableBubbleMenu(_ref) {
  var editor = _ref.editor,
      labels = _ref.labels;

  if (!editor) {
    return null;
  }

  var menuColumn = /*#__PURE__*/_jsx(Menu, {
    items: items(editor, labels)
  });

  var menuRow = /*#__PURE__*/_jsx(Menu, {
    items: itemsRow(editor, labels)
  });

  var menuTable = /*#__PURE__*/_jsx(Menu, {
    items: itemsTable(editor, labels)
  });

  var handleColorSelect = function handleColorSelect(color) {
    editor.chain().focus().setCellAttribute('backgroundColor', color).run();
  };

  return /*#__PURE__*/_jsxs(BubbleMenu, {
    editor: editor,
    tippyOptions: {
      duration: 100
    },
    shouldShow: function shouldShow(_ref2) {
      var editor = _ref2.editor,
          view = _ref2.view,
          state = _ref2.state,
          oldState = _ref2.oldState,
          from = _ref2.from,
          to = _ref2.to;
      return editor.isActive('table') || editor.isActive('tableCell') || editor.isActive('tableHeader') || editor.isActive('tableRow');
    },
    children: [/*#__PURE__*/_jsx(Tooltip, {
      title: labels.column,
      children: /*#__PURE__*/_jsx(Dropdown, {
        overlay: menuColumn,
        trigger: ['click'],
        children: /*#__PURE__*/_jsx(Button, {
          icon: /*#__PURE__*/_jsx(TableOutlined, {})
        })
      })
    }), /*#__PURE__*/_jsx(Tooltip, {
      title: labels.row,
      children: /*#__PURE__*/_jsx(Dropdown, {
        overlay: menuRow,
        trigger: ['click'],
        children: /*#__PURE__*/_jsx(Button, {
          icon: /*#__PURE__*/_jsx(TableOutlined, {})
        })
      })
    }), /*#__PURE__*/_jsx(Tooltip, {
      title: labels.table,
      children: /*#__PURE__*/_jsx(Dropdown, {
        overlay: menuTable,
        trigger: ['click'],
        children: /*#__PURE__*/_jsx(Button, {
          icon: /*#__PURE__*/_jsx(TableOutlined, {})
        })
      })
    }), /*#__PURE__*/_jsx(Tooltip, {
      title: labels.cellColor,
      children: /*#__PURE__*/_jsx(Dropdown, {
        overlay: /*#__PURE__*/_jsx(ColorTableMenu, {
          editor: editor,
          labels: labels,
          onSelectColor: handleColorSelect
        }),
        trigger: ['click'],
        children: /*#__PURE__*/_jsx(Button, {
          icon: /*#__PURE__*/_jsx(BgColorsOutlined, {})
        })
      })
    })]
  });
};

export default TableBubbleMenu;